/** @jsx jsx */
import { jsx } from "@emotion/react";
import { Fragment } from "react";
import { useIntl } from "react-intl";
import {
  SectionRow,
  UserSectionContainer,
  UserInfoContainer,
  UserLogin,
  UserName,
  buttonContainerCss,
  impersonatedUserSectionCss,
} from "./styles";
import { DeclineButton, LogOutButton } from "../../atoms/inputs/EwaButtons";
import {
  INVOKE_LOG_OUT,
  invokeRNMessage,
  isNativeApp,
} from "../../../utils/nativeUtils";

export type UserSectionProps = {
  requestLogout: () => void;
  userName: string;
  login: string;
  nameOfImpersonatedUser?: string | null;
  stopImpersonating: () => void;
};

const UserSection = ({
  userName,
  login,
  requestLogout,
  nameOfImpersonatedUser,
  stopImpersonating,
}: UserSectionProps) => {
  const { formatMessage } = useIntl();

  const isImpersonating = !!nameOfImpersonatedUser;

  const handleLogOut = () => {
    if (isNativeApp()) {
      invokeRNMessage(INVOKE_LOG_OUT, window.location.href);
    } else {
      requestLogout();
    }
  };

  return (
    <SectionRow>
      <UserSectionContainer data-cy="user-info">
        <UserInfoContainer>
          {isImpersonating && (
            <div css={impersonatedUserSectionCss}>
              <UserName>{nameOfImpersonatedUser}</UserName>
              <br />
              {formatMessage({ id: "impersonation.impersonated_by" })}
              <br />
              {userName}
            </div>
          )}

          {!isImpersonating && (
            <Fragment>
              <UserName>{userName}</UserName>
              <UserLogin>{login}</UserLogin>
            </Fragment>
          )}
        </UserInfoContainer>
        <div css={buttonContainerCss}>
          {isImpersonating && (
            <DeclineButton
              tooltip={formatMessage({
                id: "impersonation.cancel_impersonation",
              })}
              onClick={stopImpersonating}
            />
          )}
          <LogOutButton onClick={handleLogOut} />
        </div>
      </UserSectionContainer>
    </SectionRow>
  );
};

export default UserSection;
